import AccountEntityDetailsForm from './AccountEntityDetailsForm'

export default AccountEntityDetailsForm
